import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {TokenService} from '../services/token.service'
@Injectable({
    providedIn: 'root'
})
export class AuthGuard {

    constructor(      
      private tokenService:TokenService,
      protected router: Router) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        route?.queryParams?.auth_token? this.tokenService.setToken(route.queryParams.auth_token, route?.queryParams?.expires_in) : null;
        route?.queryParams?.auth_token? this.tokenService.startTimer() : null;
        const token =  route.queryParams.auth_token || localStorage.getItem('access_token');
        const expires_in = route.queryParams.expires_in || localStorage.getItem('expires_in');
        this.tokenService.subAppInitiated.next(true)
        if (token?.length && new Date(expires_in) >= new Date() ) {
            route.queryParams.lastpage ? this.router.navigate([route.queryParams.lastpage]) :null;
            return true;
        }
        const qParam = Object.assign({lastpage: state.url}, route.queryParams);
        this.router.navigate(['/login'], {queryParams: qParam});
        return false;
    }
}
